/**
 * Host-based environment helpers for Polaris UI.
 * Production is the apex polarisathletehub.com hosts only (not staging).
 */

const PRODUCTION_HOSTS = new Set(["polarisathletehub.com", "www.polarisathletehub.com"]);

/** True when the browser is on the production Polaris Athlete Hub host. */
export function isProductionHost(
    hostname: string = typeof window !== "undefined" ? window.location.hostname : "",
): boolean {
    return PRODUCTION_HOSTS.has(hostname.toLowerCase());
}

/** Staging / local tooling (e.g. media kit reset) must stay off production. */
export function isNonProductionHost(hostname?: string): boolean {
    return !isProductionHost(hostname);
}
